import { Injectable, OnDestroy } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

@Injectable({
  providedIn: 'root',
})
export class ToastService implements OnDestroy {
  private subscriptions: Subscription[] = [];
  toastDuration = 3500;
  toastPositon = 'bottom';

  constructor(
    private toastController: ToastController,
    private translateService: TranslateService
  ) {}

  public static getCssClass(cssClass?: string) {
    let css = 'tabs-bottom';
    if (cssClass) {
      css = cssClass;
    }
    return css;
  }

  async presentToast(opts: ToastOptions) {
    const formattedMessage = opts.message
      .toString()
      .replace(/(?:\r\n|\r|\n)/g, '\n');
    opts.message = formattedMessage;
    opts.cssClass += ' toast-multiline-fix';

    this.subscriptions.push(
      fromPromise(this.toastController.create(opts)).subscribe(
        async (toast) => await toast.present()
      )
    );
  }

  presentErrorToast(opts: ToastOptions, cssClass?: string) {
    if (!opts.message) {
      return;
    }
    opts.position = 'bottom';
    opts.color = 'danger';
    opts.duration = 10000;
    opts.buttons = [
      {
        icon: 'close',
      },
    ];
    opts.cssClass = ToastService.getCssClass(cssClass);

    this.presentToast(opts);
  }

  presentWarningToast(
    opts: ToastOptions,
    cssClass?: string,
    duration?: number
  ) {
    if (!opts.message) {
      return;
    }
    opts.position = 'bottom';
    opts.color = 'warning';
    opts.duration = duration ?? this.toastDuration;
    opts.cssClass = ToastService.getCssClass(cssClass);

    this.presentToast(opts);
  }

  presentSuccessToast(opts: ToastOptions, cssClass?: string) {
    if (!opts.message) {
      return;
    }
    opts.position = 'bottom';
    opts.color = 'success';
    opts.duration = this.toastDuration;
    opts.cssClass = ToastService.getCssClass(cssClass);

    this.presentToast(opts);
  }

  presentInfoToast(opts: ToastOptions, cssClass?: string) {
    if (!opts.message) {
      return;
    }
    opts.position = 'bottom';
    opts.color = 'accent';
    opts.duration = this.toastDuration;
    opts.cssClass = ToastService.getCssClass(cssClass);

    this.presentToast(opts);
  }

  presentSolidClosableToast(opts: ToastOptions, cssClass?: string) {
    if (!opts.message) {
      return;
    }
    opts.position = 'bottom';
    opts.color = 'primary';
    opts.buttons = [
      {
        icon: 'close',
      },
    ];
    opts.cssClass = ToastService.getCssClass(cssClass);

    this.presentToast(opts);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
